import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import logo from '../assets/logo.png';
import { callApi, getInlineLoader, setCookie } from "../Helpers";
import { MdLock, MdLogin, MdPerson } from "react-icons/md";

export default function Login(props) {

  const appContext = useContext(AppContext);

  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  async function init() {

  }

  async function emailLogin() {
    if (!loading) {
      if (email.trim().length > 0) {
        if (password.trim().length > 0) {

          setLoading(true);
          await callApi("email-login", {
            email: email.trim(),
            password,
          }).then((response) => {
            if (response.status === 1) {
              setCookie('userUuid', response.user.uuid);
              setCookie('userToken', response.user.token);

              appContext.tellMessage("Welcome....");
              appContext.navTo({
                item: 'dashboard',
              })
              appContext.refresh();

            } else {
              appContext.tellError(response.msg);
            }
          })
          setLoading(false);

        } else {
          appContext.tellError("Invalid Password");
        }
      } else {
        appContext.tellError("Invalid Email");
      }
    } else {
      appContext.tellInfo("Signing in, Please wait....")
    }
  }

  useEffect(() => {
    init()
  }, [ ])

  return (
    <div
      className="Login"
    >
      <div
        className="body bg-surface mShadow1"
        style={{
          borderRadius: "20px"
        }}
      >
        <div className="container">
          <div className="row">
            
            <div className="col-md-12 mb-4 mt-4">
              <div
                style={{
                  maxWidth: "300px",
                  margin: "0 auto",
                }}
              >

                <div className="mb-4 mt-4 text-center">
                  <img
                    src={logo}
                    style={{
                      width: "70%",
                      height: "auto",
                    }}
                  />
                </div>

                <h6
                  style={{
                    fontSize: "28px"
                  }}
                  className="font-semi-bold mb-5 mt-4 text-center"
                >
                  NANGUBA HOSPITAL
                </h6>

                <h6
                  style={{
                    fontSize: "20px"
                  }}
                  className="font-light mb-5 mt-4 text-center"
                >
                  Staff Login
                </h6>

                <div
                  className="input-group mb-2"
                >
                  <span className="input-group-text font-bold">
                    <MdPerson className="text-primary" size={20} /> &nbsp;
                  </span>
                  <input
                    className="form-control"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    placeholder="Enter email address"
                    type="email"
                  />
                </div>

                <div
                  className="input-group"
                >
                  <span className="input-group-text font-bold">
                    <MdLock className="text-primary" size={20} /> &nbsp;
                  </span>
                  <input
                    className="form-control"
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                    placeholder="Enter password"
                    type="password"
                  />
                </div>

                <div
                  className="mb-4 mt-4"
                >
                  <button
                    className="btn btn-primary btn-rounded btn-padded btn-block mSupportLoading font-orbitron-bold"
                    onClick={emailLogin}
                  >
                    {(loading) ? getInlineLoader() : <>Login <MdLogin className="mNoMargin mNoPadding" size={24} /></>}
                  </button>
                </div>

              </div>
            </div>
             
          </div>
        </div>
      </div>
    </div>
  )
}